/**
 * Sinh UUID v4 — có đường lui cho ngữ cảnh KHÔNG bảo mật (HTTP thuần).
 *
 * `crypto.randomUUID()` chỉ tồn tại trong secure context (HTTPS hoặc
 * localhost). Mở PWA qua `http://<IP nội bộ>:<cổng>` thì nó là `undefined`,
 * và mọi lời gọi ném `TypeError` NGAY LÚC TÍNH ĐỐI SỐ — trước cả `fetch`.
 * Triệu chứng đánh lừa: màn hình báo "Không kết nối được máy chủ" trong khi
 * tab Network trống trơn và máy chủ hoàn toàn khoẻ (11/09/2026).
 *
 * `crypto.getRandomValues` thì KHÔNG bị giới hạn secure context, nên nó là
 * đường lui đúng: vẫn ngẫu nhiên bằng nguồn của hệ điều hành, không tụt
 * xuống `Math.random`.
 *
 * LƯU Ý: hàm này chỉ cứu được UUID. `crypto.subtle` (TOTP offline),
 * `getUserMedia` (chụp ảnh) và `geolocation` vẫn đòi secure context thật —
 * môi trường chạy thật BẮT BUỘC có HTTPS. Xem docs/13 §13.4.
 */
export function uuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  const b = new Uint8Array(16)
  crypto.getRandomValues(b)
  b[6] = (b[6] & 0x0f) | 0x40 // phiên bản 4
  b[8] = (b[8] & 0x3f) | 0x80 // biến thể RFC 4122

  const hex: string[] = []
  for (let i = 0; i < 16; i++) hex.push(b[i].toString(16).padStart(2, '0'))
  return (
    hex.slice(0, 4).join('') + '-' +
    hex.slice(4, 6).join('') + '-' +
    hex.slice(6, 8).join('') + '-' +
    hex.slice(8, 10).join('') + '-' +
    hex.slice(10, 16).join('')
  )
}
